<template>
    <v-footer class="darken-5" dark>
        <v-card class="flex" flat tile>
            <v-card-title>
                <strong>Get connected with us on social networks!</strong>
                <v-spacer></v-spacer>

                <v-btn v-for="icon in icons" :key="icon" class="mx-3" dark icon>
                    <v-icon size="24px">{{ icon }}</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-actions class="justify-center">&copy;2018 — <strong>Data Chester Inc.</strong>
            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer",
        data: () => ({
            icons: [
                'fab fa-facebook',
                'fab fa-twitter',
                'fab fa-google-plus',
                'fab fa-linkedin',
                'fab fa-instagram'
            ]
        })
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/layout/Footer.vue